import React, { useEffect, useState } from "react"
import { RuleDeleteCommand, RulePostCommand } from "../../../../../../services/contractService/commands";
import { contractApi, useRuleDeleteMutation, useRuleSaveMutation } from "../../../../../../services/contractService/contract-api";
import { useAppDispatch } from "../../../../../../app/hooks";
import { useParams } from "react-router";
import { Stack } from "@mui/system";
import { TextField } from "@mui/material";
import { RuleCommands } from "./RuleCommands";

type ownProps={
    ruleId:string;
    ruleString?:string;
    ruleDescription?:string;
}

function StatusBasedCaseRate(props:ownProps){
    const {id} = useParams();
    const dispatch = useAppDispatch();
    const [rule,setRule] = useState({code:'', rate:0})
    const [saveRule] = useRuleSaveMutation();
    const [deleteRule] = useRuleDeleteMutation();
    const save=()=>{
        let command = new RulePostCommand(id!,props.ruleId,'StatusBasedCaseRate',0, JSON.stringify(rule),props.ruleDescription ?? '');
        saveRule(command).unwrap().then(()=>{dispatch(contractApi.util.invalidateTags(['ruleList']))});
    }
    const ruleDelete=()=>{deleteRule(new RuleDeleteCommand(props.ruleId))};
    useEffect(() => {
        if(props.ruleString !== ''){
            let r:{code:string,rate:number} = JSON.parse(props.ruleString!);
            setRule(r);
        }},[props.ruleString, props.ruleId]
    )
    return <React.Fragment>
        <Stack direction='row' gap={1}>
            <TextField label='Code' value={rule.code} sx={{width:'150px'}}
                onChange={(e)=>setRule({...rule,code:e.target.value})}/>
            <TextField type='number' label='Rate' value={rule.rate} sx={{width:'150px'}}
                onChange={(e)=>setRule({...rule,rate:Number(e.target.value)})}/>
        </Stack>
        <RuleCommands saveCommand={save} deleteCommand={ruleDelete} isNewRule={props.ruleId === '0' ? true:false}/>
    </React.Fragment>
}

export {StatusBasedCaseRate}